import axios from "axios";
import { DateTime } from "luxon";
import { loadNotifications } from "./notificationsActions";
import { addUserPackages } from "./userPackagesActions";
import { currentProcessingFileBase } from "../../data/userPackage/userPackageBase";
import { updateAnalytics } from "./userActions";
import {
  initSovTemplate,
  setActiveTab,
  setCurrentPopup,
  setModalsState,
  setPermitLoadings,
  setSelectedRow,
} from "./uiActions/myPermitsActions";
import { getPermitTypeData } from "../../components/permitForms/permitFormHelpers";

const getUSDate = () => {
  const today = new Date();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  const year = today.getFullYear();
  return `${month}_${day}_${year}`;
};

export const handleDownloadNoc =
  (selectedFormat, selectedSize) => async (dispatch, getState) => {
    try {
      const state = getState();
      const currentSession = state.sessions?.currentSession;
      const currentUser = state[currentSession].user;
      const { selectedRow, leftValue, currentPopup, selectedPermitType } =
        state.myPermitsComponent;

      // Determine if this is the main permit type
      //TODO: const isMainPermitType = selectedPermitType === selectedRow?.permit_type;
      const isMainPermitType = true;
      const currentPermitData = getPermitTypeData(
        selectedRow,
        selectedPermitType,
      );

      let creatingDoc = "";

      if (selectedFormat === "all") {
        creatingDoc = "all";
      } else {
        creatingDoc = currentPermitData?.selected_documents?.[leftValue]?.name;
      }

      if (selectedRow?.cst_packageID) {
        await dispatch(setPermitLoadings({ ppDownloading: true }));
      }
      const downloadLimit = currentUser?.tier?.downloads;
      const totalDownloads = currentUser?.user?.analytics?.ppDownloaded;
      const PPackageDownloaded = selectedRow?.download_info?.downloaded;

      let downloadPDF = "";
      let pdfName = "";

      if (creatingDoc === "noc") {
        pdfName = `${selectedRow?.property_owner?.name}-${selectedRow?.project_address}-${getUSDate()}`;
      }

      if (!selectedRow?.cst_packageID) {
        if (
          !selectedRow?.pp_notarized &&
          !selectedRow?.noc_notarized &&
          !selectedRow?.notarized
        ) {
          if (downloadLimit !== "Unlimited" && PPackageDownloaded === false) {
            if (parseInt(totalDownloads) >= parseInt(downloadLimit)) {
              dispatch(setCurrentPopup("downloadPayment"));
              dispatch(setModalsState({ promoModalOpen: true }));
              return { promoOpen: true };
            }
          }
        }

        const currentDate = DateTime.now().toFormat("yyyy-MM-dd");

        // Set downloading state based on whether it's "all" or a single document
        if (creatingDoc === "all") {
          await dispatch(setPermitLoadings({ ppDownloading: true }));
        } else {
          await dispatch(
            setPermitLoadings({
              downloading:
                selectedRow?.selected_documents?.[leftValue]?.name +
                selectedRow?.task_id,
            }),
          );
        }

        // Determine the download target: either "all" or the specific document's URL
        if (creatingDoc === "all") {
          downloadPDF = "all";
          pdfName = `notarized_permit_package_${currentDate}.zip`;
        } else {
          // Respect main vs additional permit when resolving document info
          if (isMainPermitType) {
            downloadPDF = selectedRow?.documents?.[creatingDoc]?.pdfUrl;
            pdfName =
              selectedRow?.documents?.[creatingDoc]?.pdfName ||
              `permit_document_${creatingDoc}_${currentDate}.pdf`;
          } else {
            const addPermit =
              selectedRow?.additional_permits?.[selectedPermitType];
            const addPermitObj = Array.isArray(addPermit)
              ? addPermit?.[0]
              : addPermit;
            downloadPDF = addPermitObj?.documents?.[creatingDoc]?.pdfUrl;
            pdfName =
              addPermitObj?.documents?.[creatingDoc]?.pdfName ||
              `permit_document_${creatingDoc}_${currentDate}.pdf`;
          }
        }

        //! PRE-SAVE DATA
        const resp = await axios.post(
          `${process.env.REACT_APP_BASE_URL}/nocApi/data/pre-save-downloaded-record`,
          {
            task_id: selectedRow?.task_id,
            currentSession: currentSession,
            currentForm:
              currentPermitData?.selected_documents?.[leftValue]?.name,
            selectedPermitType: selectedPermitType,
            mainPermitType: isMainPermitType,
          },
          { withCredentials: true },
        );

        if (
          resp?.data?.success === false &&
          resp?.data?.message === "payment_required"
        ) {
          setCurrentPopup("downloadPayment");
          dispatch(setModalsState({ promoModalOpen: true }));
          return { promoOpen: true };
        }

        if (resp?.data?.success) {
          if (resp?.data?.data) {
            await dispatch(updatePermitPackage(resp?.data?.data));
          }

          if (resp?.data?.analytics) {
            await dispatch(updateAnalytics(resp?.data?.analytics));
          }
        }
      }

      // !!!!
      // Perform the download request
      const currentForm =
        currentPermitData?.selected_documents?.[leftValue]?.name;
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/data/download-created-file`,
        {
          pdf: downloadPDF, // "all" or specific document
          currentSession: currentSession,
          type: creatingDoc === "all" ? "all" : creatingDoc, // Ensure type is passed correctly
          task_id: selectedRow?.task_id,
          addition: currentPopup,
          currentForm: currentForm,
          selectedFormat: creatingDoc === "all" ? "pdf" : selectedFormat,
          selectedSize: creatingDoc === "all" ? "legal" : selectedSize,
          cst_packageID: selectedRow?.cst_packageID,
          selectedPermitType: selectedRow?.permit_type,
          mainPermitType: true,
          //TODO: selectedPermitType: selectedPermitType,
          //TODO: mainPermitType: selectedPermitType === selectedRow?.permit_type,
        },
        {
          withCredentials: true,
          responseType: "blob", // Expect binary data in response
        },
      );

      const contentType = response.headers["content-type"];

      // // Determine file extension based on content type
      // let fileExtension = "pdf"; // Default to PDF
      // if (contentType === "image/png") {
      //   fileExtension = "png";
      // } else if (contentType === "image/jpeg") {
      //   fileExtension = "jpg";
      // } else if (contentType === "application/zip") {
      //   fileExtension = "zip";
      // }

      // Remove the existing extension and add the new one
      let fileName = "";
      if (currentForm === "noc") {
        const ownerName =
          selectedRow?.property_owner?.name ??
          selectedRow?.property_owner?.personalName;

        const createdAt = selectedRow?.documents?.noc?.created_at;
        const usDate = DateTime.fromSeconds(createdAt)
          .setZone("America/New_York")
          .toFormat("MM/dd/yyyy"); // 08/13/2025

        fileName =
          `${ownerName}-${selectedRow?.project_address}-${usDate}`.replace(
            /\.[^/.]+$/,
            "",
          );
      } else {
        fileName = pdfName.replace(/\.[^/.]+$/, "");
      }

      // Create a URL for the binary response (PDF or ZIP)
      const fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: contentType }),
      );
      // Create an anchor element to trigger the download
      const fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", fileName); // Set the correct file name (PDF or ZIP)
      document.body.appendChild(fileLink);
      fileLink.click();

      // Clean up after download
      document.body.removeChild(fileLink);
      window.URL.revokeObjectURL(fileURL);

      if (selectedRow?.cst_packageID && selectedRow?.package_type === "noc") {
        if (!selectedRow?.document?.downloaded) {
          await dispatch(
            updateCustomPermitPackageNocDownloaded(selectedRow?.cst_packageID),
          );

          const rowPayload = {
            ...selectedRow,
            document: {
              ...selectedRow.document,
              downloaded: true,
            },
          };

          await dispatch(setSelectedRow(rowPayload));
        }
      }
      if (creatingDoc === "all" || selectedRow?.cst_packageID) {
        await dispatch(setPermitLoadings({ ppDownloading: false }));
      } else {
        await dispatch(setPermitLoadings({ downloading: false }));
      }
    } catch (e) {
      console.error(e);
    } finally {
      await dispatch(
        setPermitLoadings({ ppDownloading: false, downloading: false }),
      );
    }
  };

export const getFirstNocData = (sessionName) => async (dispatch, getState) => {
  try {
    // Perform both API requests concurrently
    const [res, notificationRes, userPackagesResp] = await Promise.all([
      axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/data/get-first-noc-data`,
        { sessionName: sessionName },
        { withCredentials: true },
      ),
      axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/notification/load-notifications`,
        { sessionName: sessionName },
        { withCredentials: true },
      ),
      axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/user-packages/initial-load`,
        {
          sessionName: sessionName,
          pagination: {
            package: {
              packageLimit: 5,
              packagePage: 1,
              totalPackageRecord: 0,
            },
            form: {
              formLimit: 5,
              formPage: 1,
              totalFormRecord: 0,
            },
          },
        },
        { withCredentials: true },
      ),
    ]);

    const { totalPackageRecord, userPackages } = userPackagesResp.data;

    const updatedUserPackages = userPackages.map((packageItem) => ({
      ...packageItem,
      documents: packageItem.documents.map((doc) => ({
        ...doc, // Keep original document properties
        tempFields: currentProcessingFileBase.document.tempFields,
      })),
    }));

    const subAdminData = res?.data?.sub_admins_data;
    const appVersion = res?.data?.app_version;

    dispatch(addUserPackages(updatedUserPackages, totalPackageRecord));

    dispatch(loadNotifications(notificationRes?.data?.data));

    dispatch(loadSubAdminData(subAdminData));

    dispatch(addAppVersion(appVersion));

    await dispatch({
      type: "GET_NOC_DATA",
      payload: res?.data?.data,
    });

    return;
  } catch (error) {}
};

export const addAppVersion = (data) => {
  return {
    type: "SET_APP_VERSION",
    payload: data,
  };
};

export const loadSubAdminData = (data) => {
  return {
    type: "SET_SUB_ADMIN_DATA",
    payload: data,
  };
};

export const setUpgradeRequested = (upgrading) => {
  return {
    type: "SET_UPGRADE_REQUESTED",
    payload: upgrading,
  };
};

export const updateCustomerCoupon = (id, coupon) => {
  return {
    type: "UPDATE_CUSTOMER_COUPON",
    payload: { id, coupon },
  };
};

export const removeCustomerCoupon = (id, couponName) => {
  return {
    type: "REMOVE_CUSTOMER_COUPON",
    payload: { id, couponName },
  };
};

export const getPermitPackages =
  ({
    newPage = null,
    newPageSize = null,
    forwardNotification = null,
    customerData = null,
    customActiveTab = null,
    filters = null,
  } = {}) =>
  async (dispatch, getState) => {
    try {
      const state = getState();
      const currentSession = state.sessions?.currentSession;
      const { activeTab } = state.myPermitsComponent;
      const { pagination } = state.myPermitsComponent.permits;

      const endpoint = `${process.env.REACT_APP_BASE_URL}/nocApi/building/get-permit-package`;

      const requestData = {
        gridIndex: newPage !== null ? newPage : pagination.page,
        rowSize: newPageSize !== null ? newPageSize : pagination.pageSize,
        activeTab: customActiveTab ? customActiveTab : activeTab,
        currentSession: currentSession,
        forwardNotification: forwardNotification,
        customerData: customerData,
        currentPath: window.location.pathname,
      };

      // Add filters to request data if provided
      if (filters) {
        requestData.filters = filters;
      }

      const resp = await axios.post(endpoint, requestData, {
        withCredentials: true,
      });

      if (resp?.data?.data) {
        await dispatch({
          type: "GET_PERMIT_PACKAGES",
          payload: resp?.data?.data?.documents,
        });

        if (customActiveTab) {
          await dispatch(setActiveTab(customActiveTab));
        }

        if (forwardNotification && forwardNotification?.packageId) {
          return { success: true, data: resp?.data?.data };
        } else {
          // Ensure total_count is always a number
          const totalCount = resp?.data?.data?.total_count;
          let numericTotalCount = 0;

          if (typeof totalCount === "number") {
            numericTotalCount = totalCount;
          } else if (typeof totalCount === "string") {
            numericTotalCount = parseInt(totalCount) || 0;
          } else if (typeof totalCount === "object" && totalCount !== null) {
            // If it's an object, try to extract a number from it
            numericTotalCount = parseInt(totalCount.toString()) || 0;
          }

          // Additional safety check - if we still don't have a valid number, default to 0
          if (isNaN(numericTotalCount) || !isFinite(numericTotalCount)) {
            numericTotalCount = 0;
          }

          return { success: true, data: numericTotalCount };
        }
      } else {
        return { success: false, error: "No data received" };
      }
    } catch (error) {
      console.error(error);
      return { success: false, error: error.message || "Network error" };
    }
  };

export const clearPermitPackages = () => {
  return {
    type: "CLEAR_PERMIT_PACKAGES",
  };
};

export const getCustomers =
  ({
    page = null,
    rowsPerPage = null,
    searchTerm = null,
    filterType = null,
    fromDate = null,
    toDate = null,
  } = {}) =>
  async (dispatch, getState) => {
    try {
      const state = getState();
      const currentSession = state.sessions?.currentSession;
      const customers = state.nocData?.customers;
      const pagination = customers?.pagination || {};
      const resolvedPage =
        typeof page === "number" && page >= 0 ? page : pagination?.page || 0;
      const resolvedRowsPerPage =
        typeof rowsPerPage === "number" && rowsPerPage > 0
          ? rowsPerPage
          : pagination?.rowsPerPage || 5;
      const normalizedSearch =
        typeof searchTerm === "string"
          ? searchTerm.trim()
          : pagination?.searchTerm || "";

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/admin/getUsers`,
        {
          page: resolvedPage,
          rowsPerPage: resolvedRowsPerPage,
          search: normalizedSearch,
          filterType: filterType,
          fromDate: fromDate,
          toDate: toDate,
          currentSession: currentSession,
          currentPath: window.location.pathname,
        },
        { withCredentials: true },
      );

      if (resp?.data?.success) {
        await dispatch({
          type: "SET_CUSTOMERS",
          payload: {
            ...resp?.data?.data,
            rowsPerPage: resolvedRowsPerPage,
            searchTerm: normalizedSearch,
          },
        });

        return resp?.data?.data?.rows;
      }
    } catch (error) {
      console.error(error);
      return false;
    }
  };

export const getSavedProjects = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const currentSession = state.sessions?.currentSession;

    if (currentSession) {
      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/data/get-saved-projects`,
        {
          currentSession: currentSession,
        },
        { withCredentials: true },
      );

      await dispatch({
        type: "FIRST_ADD_SAVED_PROJECTS",
        payload: resp?.data,
      });

      await dispatch(initSovTemplate(resp?.data?.sovTemplates));

      return;
    }
  } catch (error) {
    console.error(error);
  }
};

export const handleSaveProjects = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const saved_projects = state.nocData?.saved_projects;
    await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/data/save-projects`,
      { sessionName: currentSession, saved_projects: saved_projects },
      { withCredentials: true },
    );
  } catch (error) {
    console.error(error);
  }
};

export const clearNotificationCount = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/noc/clear-notification-count`,
      { currentSession: currentSession },
      { withCredentials: true },
    );
  } catch (error) {
    console.error(error);
  }

  await dispatch({
    type: "UPDATE_NOTIFICATION_COUNT",
    payload: 0,
  });

  return;
};

export const setPermitMapping = (mapping) => {
  return {
    type: "SET_PERMIT_MAPPING",
    payload: mapping,
  };
};

export const getPermitMappingOnce = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const cachedPermitMapping = state.nocData?.permit_mapping;

    if (
      cachedPermitMapping &&
      typeof cachedPermitMapping === "object" &&
      Object.keys(cachedPermitMapping).length > 0
    ) {
      return cachedPermitMapping;
    }

    const resp = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/data/get-permit-mapping`,
      {
        currentSession,
      },
      { withCredentials: true },
    );

    if (resp?.data?.success) {
      const permitMapping = resp?.data?.data?.permit_mapping || {};
      dispatch(setPermitMapping(permitMapping));
      return permitMapping;
    }

    return {};
  } catch (error) {
    console.error(error);
    return {};
  }
};

export const getCountyAndCity = (address) => async (dispatch, getState) => {
  try {
    const state = getState();
    const currentSession = state.sessions?.currentSession;
    const currentUser = state[currentSession]?.user;

    const countyNames = (currentUser?.user?.selectedCountiesNOC || []).map(
      (item) => item.name,
    );

    // Call local Florida database instead of Google Geocoding API
    const { data } = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/nocApi/real-estate/get-county-and-city`,
      {
        address: address,
        currentSession: currentSession,
      },
      { withCredentials: true },
    );

    if (!data.success || !data.data || data.data.length === 0) {
      throw new Error("No results found in Florida property database");
    }

    // Get the first result (best match)
    const result = data.data[0];

    const county = result.county?.title;
    const city = result.city;
    const taxDistrict = result.TAX_DISTRICT || "";
    const taxDistrictDscr = result.TAX_DIST_DSCR || "";
    const municipalities = Array.isArray(result.municipalities)
      ? result.municipalities
      : [];
    const houseNumber = result.address?.number;
    const streetName = result.address?.street;

    if (!county) {
      throw new Error("County not found for this address");
    }

    if (!countyNames.includes(county)) {
      return {
        success: false,
        error: `The county "${county}" is not in your selected list. Please select it to proceed.`,
      };
    }

    const fullStreetAddress =
      houseNumber && streetName
        ? `${houseNumber} ${streetName}`
        : result.address?.full_address;

    await dispatch(loadPermitTemplate({ name: county }));

    await dispatch(
      setQuickActionAddress({
        fullStreetAddress,
        houseNumber,
        streetName,
        county,
        city,
        taxDistrict,
        taxDistrictDscr,
        municipalities,
      }),
    );
    await dispatch(setAutofillWorkType(true));
    return { success: true };
  } catch (err) {
    console.error("Florida property database lookup failed:", err.message);
    return { success: false, error: err.message };
  }
};

//  try {
//    const state = getState();
//    const currentSession = state.sessions?.currentSession;

//    if (currentSession) {
//      const resp = await axios.post(
//        `${process.env.REACT_APP_BASE_URL}/nocApi/data/get-saved-projects`,
//        {
//          currentSession: currentSession,
//        },
//        { withCredentials: true }
//      );

//      await dispatch({
//        type: "FIRST_ADD_SAVED_PROJECTS",
//        payload: resp?.data,
//      });

//      await dispatch(initSovTemplate(resp?.data?.sovTemplates));

//      return;
//    }
//  } catch (error) {
//    console.error(error);
//  }

export const loadPermitTemplate =
  (countyCard) => async (dispatch, getState) => {
    try {
      const state = getState();
      const currentSession = state.sessions?.currentSession;

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/data/get-permit-package-templates`,
        {
          currentSession: currentSession,
          countyCard: countyCard,
        },
        { withCredentials: true },
      );

      if (!resp?.data?.success) {
        return { success: false, error: resp?.data?.message };
      }

      await dispatch(setPermitPackageTemplates(resp?.data?.data));
      return { success: true };
    } catch (err) {
      // console.error("Geocoding failed:", err.message);
      return { success: false, error: err.message };
    }
  };

export const savePermitTemplate =
  (templateInfo) => async (dispatch, getState) => {
    try {
      const state = getState();
      const currentSession = state.sessions?.currentSession;

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/data/save-permit-package-template`,
        {
          currentSession: currentSession,
          templateInfo: templateInfo,
        },
        { withCredentials: true },
      );

      if (!resp?.data?.success) {
        return { success: false, error: resp?.data?.message };
      }

      await dispatch(
        savePermitPackageTemplate({
          template: resp?.data?.data,
          existing: resp?.data?.isExisting,
        }),
      );
      return { success: true, data: resp?.data?.data };
    } catch (err) {
      // console.error("Geocoding failed:", err.message);
      return { success: false, error: err.message };
    }
  };

export const deletePermitTemplate =
  (templateID) => async (dispatch, getState) => {
    try {
      const state = getState();
      const currentSession = state.sessions?.currentSession;

      const resp = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/nocApi/data/delete-permit-package-template`,
        {
          currentSession: currentSession,
          templateID: templateID,
        },
        { withCredentials: true },
      );

      if (!resp?.data?.success) {
        return { success: false, error: resp?.data?.message };
      }

      await dispatch(deletePermitPackageTemplate(templateID));
      return { success: true };
    } catch (err) {
      // console.error("Geocoding failed:", err.message);
      return { success: false, error: err.message };
    }
  };

export const setAutofillWorkTypeID = (id) => {
  return {
    type: "SET_AUTOFILL_WORKTYPE_ID",
    payload: id,
  };
};

export const setAutofillWorkType = (val) => {
  return {
    type: "SET_AUTOFILL_WORKTYPE",
    payload: val,
  };
};

export const deletePermitPackageTemplate = (templateID) => {
  return {
    type: "DELETE_PERMIT_PACKAGE_TEMPLATE",
    payload: templateID,
  };
};

export const setPermitPackageTemplates = (templates) => {
  return {
    type: "SET_PERMIT_PACKAGE_TEMPLATES",
    payload: templates,
  };
};

export const savePermitPackageTemplate = (data) => {
  return {
    type: "SAVE_PERMIT_PACKAGE_TEMPLATE",
    payload: data,
  };
};

export const setQuickActionAddress = (obj) => {
  return {
    type: "SET_QUICK_ACTION_ADDRESS",
    payload: obj,
  };
};

export const handleMarkDemoShown = () => {
  return {
    type: "ENABLE_DEMO_SHOWN",
  };
};

export const removeShowDemo = () => {
  return {
    type: "REMOVE_SHOW_DEMO",
  };
};

export const clearShowDemo = () => {
  return {
    type: "CLEAR_SHOW_DEMO",
  };
};

export const setPrevTourStep = (step) => {
  return {
    type: "SET_PREV_TOUR_STEP",
    payload: step,
  };
};

export const setShowTourNav = (bool) => {
  return {
    type: "SET_SHOW_TOUR_NAV",
    payload: bool,
  };
};

export const pushCityLog = (data) => {
  return {
    type: "PUSH_CITY_LOG",
    payload: data,
  };
};

export const addNewNotification = (data) => {
  return {
    type: "ADD_NEW_NOTIFICATION",
    payload: data,
  };
};

export const updateNotification = (data) => {
  return {
    type: "UPDATE_NOTIFICATION",
    payload: data,
  };
};

export const updateNotificationCount = (data) => {
  return {
    type: "UPDATE_NOTIFICATION_COUNT",
    payload: data,
  };
};

export const updatePermitNocForm = (noc, id) => {
  return {
    type: "UPDATE_PERMIT_NOC_FORM",
    payload: { noc: noc, task_id: id },
  };
};

export const updatePermitPackage = (obj) => {
  return {
    type: "UPDATE_PERMIT_PACKAGE",
    payload: obj,
  };
};

export const updateCustomPermitPackageNocDownloaded = (cst_packageID) => {
  return {
    type: "UPDATE_CUSTOM_PERMIT_PACKAGE_NOC_DOWNLOADED",
    payload: cst_packageID,
  };
};

export const updateCustomersRow = (row) => {
  return {
    type: "UPDATE_CUSTOMERS_ROW",
    payload: row,
  };
};

export const updatePermitPackageName = (data) => {
  return {
    type: "UPDATE_PERMIT_PACKAGE_NAME",
    payload: data,
  };
};

export const updatePermitPackageFromReturn = (obj) => {
  return {
    type: "UPDATE_PERMIT_PACKAGE_FROM_RETURN",
    payload: obj,
  };
};
export const updatePermitPackageOnFly = (obj) => {
  return {
    type: "UPDATE_PERMIT_PACKAGE_ON_FLY",
    payload: obj,
  };
};

export const updateUserPackageOnFly = (obj) => {
  return {
    type: "UPDATE_USER_PACKAGE_ON_FLY",
    payload: obj,
  };
};

export const resetScrapedFormState = (id) => {
  return {
    type: "RESET_SCRAPED_FORM_RETURN",
    payload: id,
  };
};

export const addPermitPackageSignedUrl = (document) => {
  return {
    type: "ADD_PERMIT_PACKAGE_SIGNED_URL",
    payload: document,
  };
};

export const addAvailablePermitForms = (forms, permitTypes = []) => {
  return {
    type: "ADD_AVAILABLE_PERMIT_FORMS",
    payload: { forms: forms, permitTypes: permitTypes },
  };
};
export const setPrevCityCounty = (data) => {
  return {
    type: "SET_PREV_CITY_COUNTY",
    payload: data,
  };
};

export const addCurrentPermitDocument = (document) => {
  return {
    type: "UPDATE_PERMIT_DOCUMENT",
    payload: document,
  };
};

export const removePermitDocument = () => {
  return {
    type: "REMOVE_PERMIT_DOCUMENT",
  };
};

export const addPaisTemplate = (data) => {
  return {
    type: "ADD_PAIS_TEMPLATE",
    payload: data,
  };
};

export const addSavedProjects = (data) => {
  return {
    type: "ADD_SAVED_PROJECTS",
    payload: data,
  };
};

export const pushNewProject = (data) => {
  return {
    type: "PUSH_NEW_PROJECT",
    payload: data,
  };
};

export const pushNewDynamicSavedData = (payload) => {
  return {
    type: "PUSH_NEW_DYNAMIC_SAVED_DATA",
    payload,
  };
};

export const updateNewProject = (data) => {
  return {
    type: "UPDATE_NEW_PROJECT",
    payload: data,
  };
};

export const pushNewFeeSimple = (data) => {
  return {
    type: "PUSH_NEW_FEE_SIMPLE",
    payload: data,
  };
};

export const updateNewFeeSimple = (data) => {
  return {
    type: "UPDATE_NEW_FEE_SIMPLE",
    payload: data,
  };
};

export const pushNewBonding = (data) => {
  return {
    type: "PUSH_NEW_BONDING",
    payload: data,
  };
};

export const updateNewBonding = (data) => {
  return {
    type: "UPDATE_NEW_BONDING",
    payload: data,
  };
};

export const pushNewMortgage = (data) => {
  return {
    type: "PUSH_NEW_MORTGAGE",
    payload: data,
  };
};

export const updateNewMortgage = (data) => {
  return {
    type: "UPDATE_NEW_MORTGAGE",
    payload: data,
  };
};

export const pushNewTermite = (data) => {
  return {
    type: "PUSH_NEW_TERMITE",
    payload: data,
  };
};

export const updateNewTermite = (data) => {
  return {
    type: "UPDATE_NEW_TERMITE",
    payload: data,
  };
};

export const removeSavedProject = (id) => {
  return {
    type: "REMOVE_SAVED_PROJECT",
    payload: id,
  };
};

export const enableEmptyCountyFlag = (path) => {
  return {
    type: "ENABLE_EMPTY_COUNTY_FLAG",
    payload: path,
  };
};

export const disableEmptyCountyFlag = () => {
  return {
    type: "DISABLE_EMPTY_COUNTY_FLAG",
  };
};

export const setNewTempPermitData = (data) => {
  return {
    type: "SET_NEW_TEMP_PERMIT_DATA",
    payload: data,
  };
};

export const clearNewTempPermitData = () => {
  return {
    type: "CLEAR_NEW_TEMP_PERMIT_DATA",
  };
};

export const removeFeeSimple = (id) => {
  return {
    type: "REMOVE_FEE_SIMPLE",
    payload: id,
  };
};

export const removeBonding = (id) => {
  return {
    type: "REMOVE_BONDING",
    payload: id,
  };
};

export const removeMortgage = (id) => {
  return {
    type: "REMOVE_MORTGAGE",
    payload: id,
  };
};

export const removeTermite = (id) => {
  return {
    type: "REMOVE_TERMITE",
    payload: id,
  };
};

export const pushNewPrivateProvider = (data) => {
  return {
    type: "PUSH_NEW_PRIVATE_PROVIDER",
    payload: data,
  };
};

export const updateNewPrivateProvider = (data) => {
  return {
    type: "UPDATE_NEW_PRIVATE_PROVIDER",
    payload: data,
  };
};

export const removePrivateProvider = (id) => {
  return {
    type: "REMOVE_PRIVATE_PROVIDER",
    payload: id,
  };
};

export const getLiveNocData = (nocData) => {
  return {
    type: "GET_NOC_DATA",
    payload: nocData,
  };
};

export const getPdfProgress = (nocData) => {
  return {
    type: "GET_PDF_PROGRESS",
    payload: nocData,
  };
};

export const clearPdfProgress = (id) => {
  return {
    type: "CLEAR_PDF_PROGRESS",
    payload: id,
  };
};

export const setCreatedNOC = (nocData) => {
  return {
    type: "SET_CREATED_NOC",
    payload: nocData,
  };
};

export const clearCreatedNOC = () => {
  return {
    type: "CLEAR_CREATED_NOC",
  };
};

export const onReadyToFetch = () => {
  return {
    type: "ON_READY_TO_FETCH",
  };
};

export const offReadyToFetch = () => {
  return {
    type: "OFF_READY_TO_FETCH",
  };
};

export const setRealEstatePresetsPermitPackage = (data) => {
  return {
    type: "SET_REAL_ESTATE_PRESETS_PERMIT_PACKAGE",
    payload: data,
  };
};
